// src/pages/settings/HelpSettings.js
import React from "react";
import { FaHandPointRight } from "react-icons/fa";

const HelpSettings = () => (
  <div className="stg-sub-page stg-help-page">
    <div className="stg-help-item">
      <FaHandPointRight />
      <p>
        Get in touch via email: <a href="mailto:contact@innosoftechpros.com">contact@innosoftechpros.com</a>
      </p>
    </div>
    <div className="stg-help-item">
      <FaHandPointRight />
      <p>
        Visit our website: <a href="https://ourchurchlink.com/contact-us">ourchurchlink.com/contact-us</a>
      </p>
    </div>
    <div className="stg-help-item">
      <FaHandPointRight />
      <p>
        Admin Panel Quick Guide: <a href="https://ourchurchlink.com/contact-us">Coming soon</a>
      </p>
    </div>
    <div className="stg-help-item">
      <FaHandPointRight />
      <p>
        Mobile App Quick Guide: <a href="https://ourchurchlink.com/app-preview">ourchurchlink.com/app-preview</a>
      </p>
    </div>
    <div className="stg-version-info">
      <span>App Version: 1.0 • Last Updated: October 2025</span>
    </div>
  </div>
);

export default HelpSettings;
